__turbopack_context__.v({
  "controlWrapper": "formItem-module-scss-module__UyDYjG__controlWrapper",
  "explain": "formItem-module-scss-module__UyDYjG__explain",
  "inheritLabel": "formItem-module-scss-module__UyDYjG__inheritLabel",
  "isError": "formItem-module-scss-module__UyDYjG__isError",
  "labelWrapper": "formItem-module-scss-module__UyDYjG__labelWrapper",
  "wrapper": "formItem-module-scss-module__UyDYjG__wrapper",
});
